import type { TSurveyAnswer, TSurveyQuestion } from "@/types"
import { NUMBER_TYPES } from "../../questions/constants"

export function filterAnswers(answers: TSurveyAnswer[], question: TSurveyQuestion) {
  return isStringType(question) ? filterAnswersWithComment(answers) : filterAnswersWithValue(answers)
}

type TAnswerWithValue = TSurveyAnswer & { value: number }

export function filterAnswersWithValue(answers: TSurveyAnswer[]) {
  return answers.filter((a) => {
    const { value } = a
    return value !== undefined && value !== null
  }) as TAnswerWithValue[]
}

type TCommentAnswer = TSurveyAnswer & { comment: string }

export function filterAnswersWithComment(answers: TSurveyAnswer[]) {
  return answers.filter((a) => {
    const { comment } = a
    return comment !== undefined && comment !== null && comment.length > 0
  }) as TCommentAnswer[]
}

export function isStringType({ type, is_commentable }: TSurveyQuestion) {
  return type == "string" || (type == "personal" && is_commentable)
}

export function isNumericType({ type }: TSurveyQuestion) {
  return NUMBER_TYPES.includes(type)
}
